import {
  CustomCollectionsStepAssets,
  EntryHeader,
} from "@dreambigger/shared/src/types";

/** Resolved titles and call-to-action copy for a custom step, built by merging
 *  step assets over built-in defaults. Every slot is guaranteed defined. */
export interface ResolvedCustomStepTitles {
  entryHeader: Required<EntryHeader>;
  entryAddText: string;
  entryIncompleteText: string;
}

const DEFAULT_HEADER: Required<EntryHeader> = {
  topline: "",
  title: "",
  titleAppend: "",
  subtitle: "",
  expandedTitle: "",
};

const DEFAULTS: ResolvedCustomStepTitles = {
  entryHeader: DEFAULT_HEADER,
  entryAddText: "+ Add another entry",
  entryIncompleteText: "Needs attention",
};

/** Resolve the titles and call-to-action copy for a custom step by merging the
 *  step assets over built-in defaults. */
export default function resolveCustomStepTitles(
  assets?: Partial<CustomCollectionsStepAssets>
): ResolvedCustomStepTitles {
  if (!assets) return DEFAULTS;
  return {
    entryHeader: { ...DEFAULT_HEADER, ...(assets.entryHeader ?? {}) },
    entryAddText: assets.entryAddText ?? DEFAULTS.entryAddText,
    entryIncompleteText:
      assets.entryIncompleteText ?? DEFAULTS.entryIncompleteText,
  };
}
